module.exports = __webpack_public_path__ + "static/img-soporte-90459eb9200d40e7f5899d3859180968.png";